import React, { useState } from "react";
import SearchIcon from "../../assets/svg/SearchIcon.svg";
import Add from "../../assets/svg/Add.svg";
import TrashIcon from "../../assets/svg/TrashIcon.svg";
import Editicon from "../../assets/svg/Editicon.svg";
import VanImage from "../../assets/images/carVeclese3.webp";
import OBJECTS from "../../assets/images/carVeclese2.png";
import Default from "../../assets/images/carVeclese1.webp";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import InfoItem from "../../components/InfoItem";
import { Modal } from "react-bootstrap";
import { Autocomplete, TextField } from "@mui/material";

const dummy = [
  {
    id: 1,
    images: [VanImage, OBJECTS, Default], // Use correct imported image
    "Car Model": "Honda Civic EX 2023",
    "Fuel Type": "Electric",
    "Engine Size": "1800 cc",
    "Kilometers No.": "5,000 - 15,000",
    "Tire Size": "W 22 / H 55 / D 19",
    "Battery Size": "W 22 / H 55 / D 19",
    "Transmission Type": "Automatic",
    Orders: 30,
    "Total Revenue": "50,000 EGP",
  },
  {
    id: 2,
    "Car Model": "Toyota Camry LE 2021",
    "Fuel Type": "Hybrid",
    "Engine Size": "2000 cc",
    images: [VanImage, OBJECTS, Default], // Use correct imported image
    "Kilometers No.": "15,000 - 25,000",
    "Tire Size": "W 21 / H 50 / D 18",
    "Battery Size": "W 21 / H 50 / D 18",
    "Transmission Type": "Automatic",
    Orders: 20,
    "Total Revenue": "40,000 EGP",
  },
  {
    id: 3,
    "Car Model": "Ford Focus SE 2022",
    "Fuel Type": "Gasoline",
    "Engine Size": "1600 cc",
    images: [VanImage, OBJECTS, Default], // Use correct imported image
    "Kilometers No.": "10,000 - 20,000",
    "Tire Size": "W 20 / H 55 / D 17",
    "Battery Size": "W 20 / H 55 / D 17",
    "Transmission Type": "Manual",
    Orders: 25,
    "Total Revenue": "35,000 EGP",
  },
  {
    id: 4,
    "Car Model": "BMW X5 2020",
    "Fuel Type": "Diesel",
    images: [VanImage, OBJECTS, Default], // Use correct imported image
    "Engine Size": "3000 cc",
    "Kilometers No.": "40,000 - 50,000",
    "Tire Size": "W 24 / H 60 / D 20",
    "Battery Size": "W 24 / H 60 / D 20",
    "Transmission Type": "Automatic",
    Orders: 15,
    "Total Revenue": "60,000 EGP",
  },
  {
    id: 5,
    "Car Model": "Mercedes-Benz C200 2021",
    "Fuel Type": "Gasoline",
    "Engine Size": "2500 cc",
    "Kilometers No.": "30,000 - 40,000",
    images: [VanImage, OBJECTS, Default], // Use correct imported image
    "Tire Size": "W 23 / H 55 / D 19",
    "Battery Size": "W 23 / H 55 / D 19",
    "Transmission Type": "Automatic",
    Orders: 18,
    "Total Revenue": "55,000 EGP",
  },
  {
    id: 6,
    "Car Model": "Nissan Altima 2022",
    "Fuel Type": "Hybrid",
    "Engine Size": "2200 cc",
    "Kilometers No.": "20,000 - 30,000",
    images: [VanImage, OBJECTS, Default], // Use correct imported image
    "Tire Size": "W 21 / H 50 / D 18",
    "Battery Size": "W 21 / H 50 / D 18",
    "Transmission Type": "CVT",
    Orders: 22,
    "Total Revenue": "48,000 EGP",
  },
  {
    id: 7,
    "Car Model": "Chevrolet Malibu 2023",
    "Fuel Type": "Gasoline",
    "Engine Size": "1500 cc",
    "Kilometers No.": "8,000 - 18,000",
    images: [VanImage, OBJECTS, Default], // Use correct imported image
    "Tire Size": "W 20 / H 50 / D 17",
    "Battery Size": "W 20 / H 50 / D 17",
    "Transmission Type": "Automatic",
    Orders: 27,
    "Total Revenue": "42,000 EGP",
  },
  {
    id: 8,
    "Car Model": "Kia Sportage 2021",
    "Fuel Type": "Diesel",
    "Engine Size": "2000 cc",
    "Kilometers No.": "25,000 - 35,000",
    images: [VanImage, OBJECTS, Default], // Use correct imported image
    "Tire Size": "W 22 / H 55 / D 19",
    "Battery Size": "W 22 / H 55 / D 19",
    "Transmission Type": "Automatic",
    Orders: 19,
    "Total Revenue": "46,000 EGP",
  },
];
export default function Vehicles_clientifo() {
  const Engine = ["1000cc", "1200cc", "1400cc", "1600cc", "1800cc", "2000cc"];
  const [addengine, setAddengie] = useState({
    engine: "",
  });
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const [show, setShow] = useState(false);
  const [oerderView, SetOerderView] = useState(false);
  const Close = () => setShow(false);
  const open = (order) => {
    SetOerderView(order);
    setShow(true);
  };
  return (
    <>
      <Modal show={show} onHide={Close}>
        <Modal.Header className="AddStaffModal_header">
          <Modal.Title className="Oerder-request_main">
            Edit Car Info
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row mb-5">
            <div className="col-6">
              <Autocomplete
                disablePortal
                options={Engine}
                renderInput={(params) => (
                  <TextField {...params} label="Fuel Type" />
                )}
                onChange={(event, newValue) =>
                  setAddengie({
                    ...addengine,
                    engineSize: newValue,
                  })
                }
              />
            </div>
            <div className="col-6">
              <Autocomplete
                disablePortal
                options={Engine}
                renderInput={(params) => (
                  <TextField {...params} label="Number of Kilometers" />
                )}
                onChange={(event, newValue) =>
                  setAddengie({
                    ...addengine,
                    engineSize: newValue,
                  })
                }
              />
            </div>
          </div>
          <div className="row mb-5">
            <div className="col-6">
              <Autocomplete
                disablePortal
                options={Engine}
                renderInput={(params) => (
                  <TextField {...params} label="Engine size" />
                )}
                onChange={(event, newValue) =>
                  setAddengie({
                    ...addengine,
                    engineSize: newValue,
                  })
                }
              />
            </div>
            <div className="col-6">
              <Autocomplete
                disablePortal
                options={Engine}
                renderInput={(params) => (
                  <TextField {...params} label="Transmissions Type" />
                )}
                onChange={(event, newValue) =>
                  setAddengie({
                    ...addengine,
                    engineSize: newValue,
                  })
                }
              />
            </div>
          </div>
          <div className="row mb-5">
            <div className="col-4">
              <Autocomplete
                disablePortal
                options={Engine}
                renderInput={(params) => (
                  <TextField {...params} label="Engine size" />
                )}
                onChange={(event, newValue) =>
                  setAddengie({
                    ...addengine,
                    engineSize: newValue,
                  })
                }
              />
            </div>
            <div className="col-4">
              <Autocomplete
                disablePortal
                options={Engine}
                renderInput={(params) => (
                  <TextField {...params} label="Transmissions Type" />
                )}
                onChange={(event, newValue) =>
                  setAddengie({
                    ...addengine,
                    engine: newValue,
                  })
                }
              />
            </div>
            <div className="col-4">
              <Autocomplete
                disablePortal
                options={Engine}
                renderInput={(params) => (
                  <TextField {...params} label="Transmissions Type" />
                )}
                onChange={(event, newValue) =>
                  setAddengie({
                    ...addengine,
                    engine: newValue,
                  })
                }
              />
            </div>
          </div>
          <div className="row mb-5">
            <div className="col-4">
              <Autocomplete
                disablePortal
                options={Engine}
                renderInput={(params) => (
                  <TextField {...params} label="Engine size" />
                )}
                onChange={(event, newValue) =>
                  setAddengie({
                    ...addengine,
                    engineSize: newValue,
                  })
                }
              />
            </div>
            <div className="col-4">
              <Autocomplete
                disablePortal
                options={Engine}
                renderInput={(params) => (
                  <TextField {...params} label="Transmissions Type" />
                )}
                onChange={(event, newValue) =>
                  setAddengie({
                    ...addengine,
                    engine: newValue,
                  })
                }
              />
            </div>
            <div className="col-4">
              <Autocomplete
                disablePortal
                options={Engine}
                renderInput={(params) => (
                  <TextField {...params} label="Transmissions Type" />
                )}
                onChange={(event, newValue) =>
                  setAddengie({
                    ...addengine,
                    engine: newValue,
                  })
                }
              />
            </div>
          </div>
          <TextField
            id="outlined-multiline-static"
            label="Comments"
            multiline
            className="w-100 mb-5"
            rows={4}
            defaultValue="Write client comments"
          />
          <div className="foterAddModel">
            <button type="button" className="closAddModal" onClick={Close}>
              Cancel
            </button>
            <button type="submit" className="saveAddModeal">
              Save
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <div className="Vehicles_clientifo_header spaceFirst">
        <div className="StockPage-serchBar">
          <input
            type="text"
            placeholder="Search by Car Model... "
            value={searchTerm}
            className="serchAndFilter-input_Stock"
            onChange={handleSearchChange}
          />
          <img src={SearchIcon} className="serchAndFilter-icon_Stock" />
        </div>
        <div className="stockPage_titleAndAdd">
          <div className="stockPage_add">
            <img className="stockPage_add_img" src={Add} alt="" />
            <div className="stockPage_add_text">Add New Item</div>
          </div>
        </div>
      </div>
      <Swiper
        slidesPerView={"auto"}
        spaceBetween={20}
        centeredSlides={false}
        centeredSlidesBounds={true}
        watchOverflow={true}
        loop={false}
        style={{ height: "fit-Content", maxHeight: "90%" }}
        edgeSwipeDetection={true} // Stops users from dragging too far
      >
        {dummy
          ?.filter((e) =>
            e["Car Model"].toLowerCase().includes(searchTerm.toLowerCase())
          )
          .map((vehicle) => (
            <SwiperSlide key={vehicle.id} style={{ width: "311px" }}>
              <div className="vehicle-card itemVehicle_detals">
                <Swiper
                  className="Content_Swiper"
                  style={{ marginTop: "0" }}
                  slidesPerView={1}
                  loop={true}
                  nested={true}
                  pagination={{ clickable: true }}
                  modules={[Pagination]}
                >
                  {vehicle.images.map((img, index) => (
                    <SwiperSlide key={index}>
                      <div className="image-container">
                        <img src={img} alt="car" />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
                <div className="bodyOfSwiper_clientInfo">
                  <div className="title_bodyOfSwiper_clientInfo">
                    <p>{vehicle["Car Model"]}</p>
                    <div className="d-flex">
                      <img
                        onClick={() => open(vehicle)}
                        className="Imgeflex"
                        src={Editicon}
                        alt="car"
                      />
                      <img className="Imgeflex" src={TrashIcon} alt="car" />
                    </div>
                  </div>
                  <div className="body_bodyOfSwiper_clientInfo">
                    <InfoItem
                      label="Car Model"
                      value={vehicle["Car Model"] || "No Data"}
                    />
                    <InfoItem
                      label="Fuel Type"
                      value={vehicle["Fuel Type"] || "No Data"}
                    />
                    <InfoItem
                      label="Engine Size"
                      value={vehicle["Engine Size"] || "AhmedAli@gmail.com"}
                    />
                    <InfoItem
                      label="Kilometers No."
                      value={vehicle["Kilometers No."] || "5 Vehicles"}
                    />
                    <InfoItem
                      label="Tire Size"
                      value={vehicle["Tire Size"] || "No Data"}
                    />
                    <InfoItem
                      label="Battery Size"
                      value={vehicle["Battery Size"] || "No Data"}
                    />
                    <InfoItem
                      label="Transmission Type"
                      value={vehicle["Transmission Type"] || "No Data"}
                    />
                    <InfoItem
                      label="Orders"
                      value={vehicle.Orders || "No Data"}
                    />
                    <InfoItem
                      label="Total Revenue"
                      value={vehicle["Total Revenue"] || "No Data"}
                    />
                  </div>
                </div>
                <button className="view-Morebody_Siper_clientInfo">
                  View History
                </button>
              </div>
            </SwiperSlide>
          ))}
      </Swiper>
    </>
  );
}
